import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@naf-simba/elements-buttons';
import { Lock } from '@naf-simba/building-blocks-icons/Safety';
import { Text, TextVariant } from '@naf/text';
import { useLocation } from 'react-router';
import { useLoginRedirect } from '@hooks/useLoginRedirect';

const MustLogIn = () => {
  const location = useLocation();
  const { redirectToLoginPage } = useLoginRedirect();

  const handleLogin = () => {
    redirectToLoginPage(location.pathname);
  };

  return (
    <div>
      <LogInText variant={TextVariant.ArticleText}>
        For å sende inn spørsmål er du nødt til å være logget inn.
      </LogInText>
      <Button endIcon={Lock} onClick={handleLogin}>
        Logg inn
      </Button>
    </div>
  );
};

const LogInText = styled(Text)`
  margin-top: 0;
`;

export { MustLogIn };
